"use client"

import { useEffect, useState } from "react"

import { HydrationBoundary, QueryClientProvider, type DehydratedState } from "@tanstack/react-query"

import { createQueryClient } from "@/platform/query/create-query-client"
import { watchViewer } from "@/platform/session/retire"
import { SessionProbe } from "@/platform/session/SessionProbe"
import { syncSessionAcrossTabs } from "@/platform/session/sync"

export const TanStackQueryWrapper = ({ children, state }: { children: React.ReactNode; state?: DehydratedState }) => {
  const [client] = useState(createQueryClient)

  useEffect(() => {
    const stopWatching = watchViewer(client)
    const stopSyncing = syncSessionAcrossTabs(client)
    return () => {
      stopWatching()
      stopSyncing()
    }
  }, [client])

  return (
    <QueryClientProvider client={client}>
      <HydrationBoundary state={state}>
        <SessionProbe />
        {children}
      </HydrationBoundary>
    </QueryClientProvider>
  )
}
